var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showPanel
    ? _c("div", { staticClass: "scene-info-panel" }, [
        _c("div", { staticClass: "scene-header-row" }, [
          _c("div", { staticClass: "scene-title-section" }, [
            _c("div", { staticClass: "scene-title-row" }, [
              _c("span", { staticClass: "scene-icon" }, [
                _vm._v(_vm._s(_vm.getSceneIcon())),
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(_vm.currentScene.name))]),
              _vm._v(" "),
              _c("div", { staticClass: "location-badge" }, [
                _vm._v(_vm._s(_vm.gameState.location)),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "scene-background" }, [
            _c("p", { staticClass: "background-text" }, [
              _vm._v(_vm._s(_vm.currentScene.background)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "available-actions panel-section" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-grid" },
            _vm._l(_vm.suggestedActions, function (action) {
              return _c(
                "div",
                {
                  key: action.id,
                  staticClass: "action-item",
                  class: { "action-disabled": !action.implemented },
                  on: {
                    click: function ($event) {
                      action.implemented && _vm.executeAction(action.command)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "action-icon" }, [
                    _vm._v(_vm._s(action.icon)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "action-content" }, [
                    _c("div", { staticClass: "action-text" }, [
                      _c("div", { staticClass: "action-name" }, [
                        _vm._v(_vm._s(action.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "action-desc" }, [
                        _vm._v(_vm._s(action.description)),
                      ]),
                    ]),
                    _vm._v(" "),
                    !action.implemented
                      ? _c("div", { staticClass: "coming-soon" }, [
                          _vm._v("即将开放"),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "scene-features panel-section" }, [
          _c("div", { staticClass: "panel-header features-header" }, [
            _c("span", { staticClass: "panel-header-icon features-icon" }, [
              _vm._v("✨"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "panel-header-title features-title" }, [
              _vm._v(_vm._s(_vm.currentScene.name) + "特色"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "features-grid" },
            _vm._l(_vm.sceneFeatures, function (feature) {
              return _c(
                "div",
                { key: feature.id, staticClass: "feature-item" },
                [
                  _c("span", { staticClass: "feature-icon" }, [
                    _vm._v(_vm._s(feature.icon)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "feature-text" }, [
                    _vm._v(_vm._s(feature.text)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "scene-atmosphere" }, [
      _c("span", { staticClass: "atmosphere-indicator" }, [
        _c("span", { staticClass: "pulse-dot" }),
        _vm._v("\n            灵气充裕\n          "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "time-indicator" }, [
        _c("span", { staticClass: "time-icon" }, [_vm._v("🌙")]),
        _vm._v("\n            深夜\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-header actions-header" }, [
      _c("span", { staticClass: "panel-header-icon actions-icon" }, [
        _vm._v("⚡"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "panel-header-title actions-title" }, [
        _vm._v("建议行动"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }